import { logger } from '@breville/xps-utils/core-ts/logger';
import { AuthUser } from '../context/authContext';
import { apiClient } from './service';

/**
 * Fetches the authenticated user's account details from the backend.
 * Token is injected automatically by the apiClient interceptor in service.ts.
 * Mirrors chefsteps-ui/src/library/api/userServices.ts
 */
export const getUserDetail = async (): Promise<AuthUser | null> => {
  try {
    const response = await apiClient.get<AuthUser>('/api/v0/users/account');
    return response.data;
  } catch (err) {
    logger.error('getUserDetail', { err });
    return null;
  }
};
